(function (win, $, eventhub) {
	'use strict';
	var uid                   = 1;
    var pluginName            = 'PMWithdrawList';
	var iScrollClassName      = 'scrollable_wd_list';
    var ghostClickElapsedTime = 30;
	var lastEventTimestamp;
	var msg;
	var constants = {
		noPendingWdClassName : 'noPendingWD',
		invisibleClassName : 'hidden',
		supportedImageMimeType : {
			"image/gif"     : 1,
			"image/jpeg"    : 1,
			"image/png"     : 1,
			"image/svg+xml" : 1
		},
		resourceTypeUrl        : 'url'
	};
	var defaultOptions = {                 // Define default options about the plugin configuration
		iScroll                : {                // Object that represent iScroll behavior
			className             : '.' + iScrollClassName,
			scrollX               : false,
			scrollY               : true,
			mouseWheel            : true,
			scrollbars            : true,
			interactiveScrollbars : true,
			tap                   : true,
			shrinkScrollbars      : 'scale'
		},
		toggleFunctionality : {
			isShowList: true,
			isVisibleBtn: false,
			slideDownTitle: 'Show',
			slideUpTitle : 'Hide',
			slideAnimation: 0
		},
        isScrollEnabled	    : true,
        useIntl	    		: false,
		pluginWrapper       : '<div class="section_content"><div class="wd_request_list scrollable <%- iScrollClassName %>"><div class="tbl_wrap"></div></div></div>',
		tableHead		    : '',
		sledBtnControllTemplate : '<button id="toggleButton" class="btn-xs btn-small btn-cancel"> <%= title %></button>',
		btnCanceling        : '<button class="btn-xs btn-small btn-cancel"><%= cancel%><i class="btnicon btnicon-progress">&nbsp;</i></button>',
		row_details         : '<tr class="details_row"><td>&nbsp;</td><td colspan="3" id="wd_detail_<%- wd_requestId %>"></td></tr>',
		row_details_content : '<table class="withdraw_details"><tbody><% _.each(data, function(o){ %><tr><td><%= o.text %></td></tr><% }); %></tbody></table>',
		row_plus            : '<tr><td><%if (haveOrders){ %><div data-id=\"<%- id%>\" class=\"ddimage details_open\" ></div><%} else {%>&nbsp;<%}%></td><td class=\"wd_date\"><%- date%></td><td class=\"wd_status\"><%= statusLine%></td><td class=\"wd_button\"><%= button%></td></tr>',
		statusTemplates     : {
			'approved'   : '<button data-id="<%- id%>" class="btn-xs btn-small btn-cancel"><%= btnLabel%></button>',
			'declined'   : '&nbsp;',
			'partial'    : '&nbsp;',
			'in_process' : '<button data-id="<%- id%>" class="btn-xs btn-small btn-cancel"><%= btnLabel%></button>',
			'pending'    : '<button data-id="<%- id%>" class="btn-xs btn-small btn-cancel"><%= btnLabel%></button>',
			'canceled'   : '&nbsp;'
		},
		pmsClassPrefix : 'wd_smallpms_',
		dateformatter : function(date){ return date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear(); },
		currencyFormatter : function (currency, value) {var currencyMap = {}; if (currencyMap[currency.toLowerCase()]) {return currencyMap[currency.toLowerCase()] + value;} return value + " " + currency.toUpperCase();},
		customCssObjCreator : function(imgUrl, className){ return {background: "url('"+ imgUrl+ "') no-repeat center center;"}; },
		customCssRuleSelectorSufix: '', // '' | '::after' | '::before',
		no_pending_withdrawals : 'No pending withdrawals',
		stateMutator : function (wdRequest) {
			return wdRequest['renderingState'];
		},
		toggleButtonParentSelector: ''
	};

	function _createLoTpls(ctx) {
		var self = ctx;
		_.each([
			'pluginWrapper', 'tableHead', 'sledBtnControllTemplate', 'btnCanceling', 'row_details', 'row_details_content',
			'row_plus', 'statusTemplates.approved', 'statusTemplates.declined', 'statusTemplates.partial',
			'statusTemplates.in_process', 'statusTemplates.pending', 'statusTemplates.canceled'
		], function (prop) {
			var ps = prop.split('.');
			if (ps.length === 2 && (typeof self.options[ps[0]][ps[1]] === 'string')) {
				self.options[ps[0]][ps[1]] = _.template(self.options[ps[0]][ps[1]]);
			} else if (typeof self.options[prop] === 'string') {
				self.options[prop] = _.template(self.options[prop]);
			}
		});
	}
	function PMWithdrawList(element, externalOptions) {
		var self = this;
        this.options = $.extend(true, {}, defaultOptions, externalOptions);
        this.options.iScroll.className = this.options.iScroll.className + '_' + uid;
		_createLoTpls(self);
        this.options.pluginWrapper     = this.options.pluginWrapper({iScrollClassName : iScrollClassName + '_' + uid});
        this.$targetEl = $(element);
        this.$targetEl.append(this.options.pluginWrapper);
        this.$wd_request_list = $("div.wd_request_list", this.$targetEl);
        this.$tbl_wrap = $("div.tbl_wrap", this.$targetEl);
		this.withdrawData = [];
		this.tableWrapperV = ['<table>', this.options.tableHead];
		this.iScroll = null;
		eventhub.subscribe('withdraws-available', this.render, this);
		eventhub.subscribe('withdraw-cancel-start', _onWithdrawCancelStart, this);
		this.init();
	}


	PMWithdrawList.prototype.init = function () {
        msg = app.msg || app.locale;
		var toggleOptions = this.options.toggleFunctionality;
        cssCreator.setup(this.options.cssCreator);
		if (toggleOptions.isVisibleBtn) {
			var $slideBtn = $(this.options.sledBtnControllTemplate({
				title: toggleOptions.isShowList ? toggleOptions.slideUpTitle : toggleOptions.slideDownTitle
			}));
			if(this.options.toggleButtonParentSelector){
				$(this.options.toggleButtonParentSelector).append($slideBtn)
			}else{
				$slideBtn.insertAfter($('.section_content', this.$targetEl));
			}
			this.$slideBtn = $slideBtn;
			$slideBtn.click(function () {
				if(toggleOptions.isShowList){
					this.hide();
				}
				else{
					this.show();
				}
			}.bind(this));
		}
		if (toggleOptions.isShowList) {
            this.show();
        }
		else {
            this.hide();
        }

		this.$wd_request_list.delegate("table tr td .btn-cancel", 'click tap', _.bind(_onClickCancelButton, this));
		this.$wd_request_list.delegate("table tr td > div.details_open", 'click tap', _.bind(_onClickPlusButton, this));
		this.$wd_request_list.delegate("table tr td > div.details_close", 'click tap', _.bind(_onClickMinusButton, this));

		$(window).resize(_.bind(this.updateScroll, this));
	};

	PMWithdrawList.prototype.render = function (data) {
		this.$targetEl.attr("data-count", data.length);
		
		if (data && data.length == 0) {
			this.$targetEl.addClass(constants.noPendingWdClassName);
			this.$tbl_wrap.html("<div class='no_pending_withdrawals'>" + this.options.no_pending_withdrawals + "</div>");
		}
		else {
			this.$targetEl.removeClass(constants.noPendingWdClassName);
			if( this.options.inLightbox ){
				data = _getCancelableWDs(data);
			}
			//this.empty();
			this.withdrawData = data;
			var tableHead = this.options.tableHead;
			this.tableWrapperV =  ['<table>', tableHead()];
			_.each(this.withdrawData, _eachWithdrawData, this);
			this.$tbl_wrap.html(this.tableWrapperV.join('')+'</table>');
			this.updateScroll();
			eventhub.publish('pm-rendered');
			this.iScroll.refresh();
		}
		eventhub.publish('app.event.pmwithdrawlist.postRender', [{data_length: (data.length || 0), data_type:"wd_request_list"}]);
	};

	PMWithdrawList.prototype.updateScroll = function () {
		var self = this;
		var fakeScrollObj = function () {
			this.isFake = true;
			this.refresh = _.identity;
			this.scrollToElement = _.identity;
			this.scrollTo = _.identity;
			this.destroy = _.identity;
			this.scrollBy = _.identity;
			this.on = _.identity;
		};
		var pmScroller = self.iScroll;

		if (pmScroller && !pmScroller.isFake) {
			var $wrapper = $(pmScroller.wrapper);
			pmScroller.refresh();
			if (pmScroller.scrollerHeight > $wrapper.height()) {
				$('.iScrollLoneScrollbar', $wrapper).removeClass(constants.invisibleClassName);
			} else {
				$('.iScrollLoneScrollbar', $wrapper).addClass(constants.invisibleClassName);
			}
		} else if (self.options.isScrollEnabled && (self.$tbl_wrap.height() > self.$wd_request_list.height())) {
			self.iScroll = new IScroll(self.options.iScroll.className, self.options.iScroll);
		} else {
			self.iScroll = new fakeScrollObj();
		}
	};


	PMWithdrawList.prototype.openPM = function ( pmID ) {
		if(!arguments.length) return;

		var withdraw = _.find(this.withdrawData, { 'wd_requestId' : pmID.toString() });
		_onWithdrawFind.call(this, withdraw);

		this.iScroll.refresh();
	};

	PMWithdrawList.prototype.show = function () {
		var self = this;
		var options = this.options.toggleFunctionality;
		if(this.$slideBtn){
			this.$slideBtn.text(options.slideUpTitle).removeClass('show').addClass('hide');
		}
		this.$wd_request_list.slideDown(options.slideAnimation).removeClass('hide').addClass('show');
		options.isShowList = true;
		self.updateScroll();
		setTimeout(function () {
			self.iScroll.refresh();
		}, 100);
		eventhub.publish('show-pmWithdrawList');

	};

	PMWithdrawList.prototype.hide = function () {
		var options = this.options.toggleFunctionality;
		if(this.$slideBtn){
			this.$slideBtn.text(options.slideDownTitle).removeClass('hide').addClass('show');
		}
		this.$wd_request_list.slideDown(options.slideAnimation).removeClass('show').addClass('hide');
		options.isShowList = false;
        eventhub.publish('hide-pmWithdrawList');
	};

	PMWithdrawList.prototype.empty = function () {
		this.$tbl_wrap.empty();
		this.withdrawData = [];

		this.$tbl_wrap.html("<div class='no_pending_withdrawals'>" + this.options.no_pending_withdrawals + "</div>");
	};

	PMWithdrawList.prototype.destroy = function () {
		$(this.$targetEl).remove();

		delete this.withdrawData;
		delete this.$targetEl;
		delete this.$targetEl;
		delete this.$wd_request_list;
		delete this.options;
		delete this.withdrawData;
		delete this.tableWrapperV;
		delete this.iScroll;
	};

	function _onClickPlusButton(event) {
        var currentEventTime = (new Date()).getTime();
		if (currentEventTime - lastEventTimestamp < ghostClickElapsedTime) {
            return true;
		}
		this.openPM($(event.target).attr("data-id"));

        lastEventTimestamp = currentEventTime;
        event.preventDefault();
        event.stopPropagation();
	}

	function _onClickMinusButton(event) {
        var currentEventTime = (new Date()).getTime();
        if (currentEventTime - lastEventTimestamp < ghostClickElapsedTime) {
            return true;
		}
		var $targetElm = $(event.currentTarget);
		var detailsRow = $targetElm.parent().parent().next();
		var self = this;

		detailsRow.hide('slideUp', function () {
			detailsRow.remove();
			self.iScroll.refresh();
		});

		$targetElm.removeClass('details_close').addClass('details_open');

        lastEventTimestamp = currentEventTime;
        event.preventDefault();
        event.stopPropagation();
	}

	function _onWithdrawFind(data) {
		var tableWrapper = $('table > tbody', this.$targetEl);
		var $targetEl = $('tr > td div[data-id="' + data.wd_requestId + '"]', $(tableWrapper));
		var prefix = this.options.pmsClassPrefix;
		var formOrders = _.map(data.orders, function (order) {
			order.poName = _.escape(order.poName) || '';
			order.upoName = _.escape(order.upoName) || '';
			order.upoName = order.upoName.toLowerCase();
			order.status = order.status.toLowerCase();
			var statusString = msg.wd_req_detail[order.status] || '';

			var localeString = '<span>' + statusString + '</span>';
			var pm_class = prefix + order.poName.toLowerCase();
			if (order.poName === 'cc_card' || order.poName === 'dc_card') {
				pm_class = prefix + order.card_type;
			}
			var url = _getUrl(order.metadata);
			if (url) {
				pm_class = pm_class + '_' + order['upoId'] + '_modified';
				var cssObj = this.options.customCssObjCreator(url, pm_class);
				cssCreator.addCustomRule(pm_class + this.options.customCssRuleSelectorSufix, cssObj);
			}
			var pm_image = '<span class="' + pm_class + '"></span>';
			var upo_name = '<span style="color:#B31838">(' + order.upoName + ')</span>';
			var amount = '<span>' + (this.options.useIntl ? this.options.currencyFormatter(order.currency, order.amount) : order.amount);
			var currency = (this.options.useIntl ? "" : order.currency) + '</span>';
			return {text: localeString.format(pm_image, upo_name, amount, currency)};
			/*
			return {
				text : localeString.format(pm_image,
					'<span style="color:#B31838">(' + order.upoName + ')</span>',
					'<span>' + order.amount, order.currency + '</span>')
			};
			*/
		}, this);

		$($targetEl).removeClass('details_open').addClass('details_close');

		$($targetEl).parents('tr').after(this.options.row_details({wd_requestId: data.wd_requestId, orders: data.orders, wdStatus : data.status}));

        var $detailsEl = $('td#wd_detail_' + data.wd_requestId, $(tableWrapper));
        $detailsEl.html(this.options.row_details_content({data: formOrders }));
	}

	function _onClickCancelButton(event) {
        var currentEventTime = (new Date()).getTime();
        if (currentEventTime - lastEventTimestamp < ghostClickElapsedTime) {
            return true;
        }

		var wdRequestIdToCancel = parseInt($(event.target).attr("data-id"));
		eventhub.publish('withdraw-cancel', [{id : wdRequestIdToCancel}]);

        lastEventTimestamp = currentEventTime;
        event.preventDefault();
        event.stopPropagation();
	}

	function _onWithdrawCancelStart(data) {
		var $btn = $('button[data-id=' + data.buttonId + ']', this.$targetEl);
		var $newBtn = $(this.options.btnCanceling(msg));
		$newBtn.attr("disabled", true);
		$btn.parent().html($newBtn);
	}

	function _eachWithdrawData(wds) {
		var statusTemplates = this.options.statusTemplates;
		var currencyFormatter = this.options.currencyFormatter;
		var prefix          = this.options.pmsClassPrefix;
		var orders          = wds['orders'] || [];
		var haveOrders      = !!orders.length;
		var status          = wds['status'].toLowerCase();
        var date            = isNaN(parseInt(wds['creationDate'])) ? wds['creationDate'] : (new Date(parseInt(wds['creationDate'])));
		var wds_params      = wds.params || {poName : ''};
		var renderingState  = this.options.stateMutator(wds); //wds['renderingState'];

		var po_displayName  = haveOrders ? _.escape(orders[0].poDisplayName) : _.escape( wds_params.poDisplayName);
		var issuerBankName	= haveOrders ? _.escape(orders[0].issuerBankName) : _.escape( wds_params.issuerBankName);
		var ccCardSource	= haveOrders ? _.escape(orders[0].ccCardSource) : _.escape( wds_params.ccCardSource);
		var requestedAmount = wds['requestedAmount'];
		var requestedCurrency = wds['requestedCurrency'];
		var button_cancel   = "&nbsp;";
		var formattedDate   = this.options.dateformatter(date);

		var item            = haveOrders ? orders[0] : wds_params;
		var upo_name        = _.escape(item.upoName);
		var pm_class        = prefix + _.escape((item.poName || '').toLowerCase());
		var pmClassReal     = _.escape((item.poName || '').toLowerCase());
		var po_name         = _.escape((item.poName || '').toLowerCase());
		var url       		= _getUrl(item.metadata);

		if (item.poName === 'cc_card' || item.poName === 'dc_card') {

            pm_class = prefix + _.escape(item.card_type);
            pmClassReal = _.escape(item.card_type);
        }
		if (url) {
			pm_class = pm_class + '_' + wds['wd_requestId'] + '_modified';
			var cssObj = this.options.customCssObjCreator(url, pm_class);
			cssCreator.addCustomRule(pm_class + this.options.customCssRuleSelectorSufix, cssObj);
		} else {
			cssCreator.makeRule(pmClassReal);
		}

		if (renderingState === 'CANCELABLE') {
			button_cancel = statusTemplates[status]({id: wds['wd_requestId'], btnLabel: msg.cancel});
		} else {
			button_cancel = statusTemplates.canceled({});
		}

		this.tableWrapperV.push(this.options.row_plus({
			id              : wds['wd_requestId'],
			date            : formattedDate,
			amount          : requestedAmount,
			currency        : requestedCurrency,
			status          : status,
			pm_class_real   : pmClassReal,
			statusLine      : msg.status_line[status].format('<span class="amount_sum">' + currencyFormatter(requestedCurrency, requestedAmount) + '</span>', '<span class="wd_states wd_' + status + '">' + msg.state_text[status] + '</span>'),
			button          : button_cancel,
			pm_class        : pm_class,
			upo_name        : upo_name,
			po_name         : po_name,
			po_displayName  : po_displayName,
			issuerBankName  : issuerBankName,
			ccCardSource	: ccCardSource,
			imgUrl			: url || '',
			haveOrders      : haveOrders

		}));
	}

	function _getCancelableWDs (data) {
		return _.filter(data, function (w) {
			return w.renderingState == 'CANCELABLE' && w.status != 'CANCELED';
		});
	}

	function _getUrl(metadata) {
		var url;
		if (metadata && metadata.imgContent && metadata.imgMimeType) {
			if (constants.supportedImageMimeType[metadata.imgMimeType]) {
				var normalizedString = (metadata.imgContent).replace(/(\r\n|\n|\r)/gm, "");
				url = ["data:", metadata.imgMimeType, ";base64,", normalizedString].join('');
			} else if (metadata.imgMimeType === constants.resourceTypeUrl) {
				url = metadata.imgContent.trim();
			}
		}
		return url;
	}

	$.fn[pluginName] = function (options) {
		return this.each(function () {
			var _pluginName = 'plugin_' + pluginName;

			if (!$.data(this, _pluginName)) {
				$.data(this, _pluginName, new PMWithdrawList(this, options));
				uid +=1;
			}
		});
	}
}(window, $, pubsub));